import React from 'react';

import { PLAYBOOK_VIEW_TYPE, PLAYBOOK_VIEW_TYPE_LABEL } from '../../../../../constants/playbooks';

import { Input, Select } from '../../../../../design-system';
import TabSettingsSection from '../TabSettingsSection/TabSettingsSection';

const VIEW_TYPE_OPTIONS = [
    { id: PLAYBOOK_VIEW_TYPE.tabs, name: PLAYBOOK_VIEW_TYPE_LABEL[PLAYBOOK_VIEW_TYPE.tabs] },
];

const PlaybookViewPanelForm = ({
    formData,
    setTabs,
    playbookId,
    fieldErrorMessages,
    handleInputChange,
}) => {
    return (
        <div className="flex flex-col gap-5">
            <div className="flex flex-col gap-5 pb-5 border-b border-neutral-200">
                <Select
                    size="sm"
                    name="view_type"
                    value={formData.view_type}
                    options={VIEW_TYPE_OPTIONS}
                    label="View Type"
                    isRequired
                    onChange={(value) => handleInputChange('view_type', value)}
                    placeholder="Select an option"
                    state={fieldErrorMessages.view_type ? 'error' : 'default'}
                    errorMessage={fieldErrorMessages.view_type}
                />

                <Input
                    size="sm"
                    name="view_name"
                    value={formData.name}
                    label="View Name"
                    isRequired
                    onChange={(e) => handleInputChange('name', e.target.value)}
                    state={fieldErrorMessages.name ? 'error' : 'default'}
                    errorMessage={fieldErrorMessages.name}
                    placeholder="Give this view a unique name"
                />

                <Input
                    size="sm"
                    name="view_description"
                    value={formData.description}
                    label="View Description"
                    isRequired
                    onChange={(e) => handleInputChange('description', e.target.value)}
                    state={fieldErrorMessages.description ? 'error' : 'default'}
                    errorMessage={fieldErrorMessages.description}
                    placeholder="Describe what this view is for"
                />
            </div>

            {formData.view_type === PLAYBOOK_VIEW_TYPE.tabs && (
                <TabSettingsSection
                    formData={formData}
                    setTabs={setTabs}
                    playbookId={playbookId}
                    fieldErrorMessages={fieldErrorMessages}
                />
            )}
        </div>
    );
};

export default PlaybookViewPanelForm;
